export interface SpotGeometry {
  x: number;
  y: number;
  w: number;
  h: number;
  maxWidthIn: number;
  maxHeightIn: number;
}

// Pixel box for a logo on a garment photo: centered in the spot, aligned to its top, then moved by the placement's
// offset (src/lib/offset.ts, already clamped to the spot). No offset is the standard box, to the pixel. No imports here.
export function placement(
  spot: SpotGeometry,
  ppi: number,
  widthIn: number,
  heightIn: number,
  offset?: { offsetXIn?: number; offsetYIn?: number },
) {
  const width = Math.round(widthIn * ppi);
  const height = Math.round(heightIn * ppi);
  const dx = Math.round((offset?.offsetXIn ?? 0) * ppi);
  const dy = Math.round((offset?.offsetYIn ?? 0) * ppi);
  return { left: Math.round(spot.x + (spot.w - width) / 2) + dx, top: Math.round(spot.y) + dy, width, height };
}

// The same box reflected about the photo's vertical center line. S&S frames a style's front and back photos alike,
// so the front-center box mirrored onto the back photo is where a full-back print sits.
export function mirrorSpot(spot: SpotGeometry, photoWidth: number): SpotGeometry {
  return { ...spot, x: photoWidth - spot.x - spot.w };
}
